export const NINETY_MINUTES_IN_MILLISECONDS = 90 * 60 * 1000;
export const TWO_HOURS_IN_MILLISECONDS = 120 * 60 * 1000;
export const THREE_HOURS_IN_MILLISECONDS = 180 * 60 * 1000;
export const ONE_DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000;
